// Validation des variables d'environnement frontend (VITE_*).
// Source : PRD 09 §3 + PRD 20 §4.4 deploy.
//
// Les VITE_* sont inlinées dans le bundle au build → elles ne doivent PAS
// contenir de secrets (service_role key, etc.). Seul l'anon key Supabase est
// acceptable côté client (il est gated par RLS).
import { z } from "zod";

const EnvSchema = z.object({
  VITE_SUPABASE_URL: z.string().url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(20),
  VITE_POSTHOG_KEY: z.string().optional(),
  VITE_POSTHOG_HOST: z.string().url().optional(),
});

export type AppEnv = z.infer<typeof EnvSchema>;

let cached: AppEnv | undefined;

/**
 * Charge + valide les variables d'environnement au premier accès.
 * Throw en dev ET en prod si les obligatoires manquent — fail fast (OWASP ASVS
 * V14.3.2 fail securely). Un bundle déployé sans env config ne doit JAMAIS
 * envoyer des tokens à un domaine fallback (DNS hijack risk).
 * L'ErrorBoundary catch l'exception et affiche un écran d'erreur clair.
 */
export function getEnv(): AppEnv {
  if (cached) return cached;

  const result = EnvSchema.safeParse(import.meta.env);
  if (!result.success) {
    const missing = result.error.issues.map((i) => i.path.join(".")).join(", ");
    console.error("[env] Invalid/missing VITE_* env vars :", result.error.issues);
    throw new Error(
      `[xymail] Missing required environment variables : ${missing}. ` +
        `Check .env.local (dev) or Netlify/Vercel config (prod).`,
    );
  }

  cached = result.data;
  return cached;
}
